import { render, staticRenderFns } from "./StockKDJ.vue?vue&type=template&id=6c7f82e8&scoped=true"
import script from "./StockKDJ.vue?vue&type=script&lang=js"
export * from "./StockKDJ.vue?vue&type=script&lang=js"
import style0 from "./StockKDJ.vue?vue&type=style&index=0&id=6c7f82e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7f82e8",
  null
  
)

export default component.exports